import { useEffect, useRef, useState } from "react";
import EnhancedSearchStore from "../../UI/enhancedstoresearch";
import PharmacyInfo from "./pharmacyInfo";
import ProductAvailability from "./productAvability";
import Select from "react-select"
const ProductBasicInfo = ({
  productData,
  setProductData,
  categories,
  setAvailability,
  availability,
  errors,
  stores,
  mode ,
  product ,setSectionType ,section_type ,setPharmacyInfo ,pharmacyInfo ,setErrors ,setPrices ,setSectionId , isCategoriesLoading ,is_vendor
}) => {
  const firstRender = useRef(false);
const [categoryValue,setCategoryValue]=useState(null)
  useEffect(() => {
  if (productData?.category_id) {
    setCategoryValue({
      value: productData.category_id,
      label: productData.category_name,
    });
  } else {
    setCategoryValue(null);
  }
}, [productData?.category_id, productData?.category_name 
]);


const groupedOptions = categories.map(cat => {
  if (cat.subcategories && cat.subcategories.length > 0) {
  
    return {
      label: cat.name,
      options: cat.subcategories.map(sub => ({
        label: sub.name,
        value: sub.id,
        parentId: cat.id, 
      })),
    };
  } else {
   
    return {
      label: cat.name,
      value: cat.id,
    };
  }
})


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setProductData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? (checked ? 1 : 0) :type ==="number"? +value:value,
    })

  );


setErrors(prev => {
  const updatedErrors = { ...prev };
  delete updatedErrors[name];
  return updatedErrors;
});
  };

  const handleChangeCategoryId= (selectedOption)=>{
  if (!selectedOption) {
    setProductData(prev => ({
      ...prev,
      category_id: null,
      category_name: null,
    }));
    setCategoryValue(null);
    return;
  }
  setErrors(prev => {
  const updatedErrors = { ...prev };
  delete updatedErrors["category_id"];
  return updatedErrors;
});
  setProductData((prev)=>({
    ...prev,
      category_id: selectedOption.value,
    category_name: selectedOption.label,

  }))
}

  const setStoreId = (id ,name) => {
  setProductData((prev) => ({
    ...prev,
    store_id: id,
    store_name:name
  })

);
  setProductData((prev)=>({
    ...prev,
    category_id:null,
    category_name:null
  }))
  setCategoryValue(null)
setErrors(prev => {
  const updatedErrors = { ...prev };
  delete updatedErrors["store_id"];
  return updatedErrors;
});
};

  return (
    <div className="basic-info">
      <h6 className=" mb-2">المعلومات الأساسية</h6>
      <div className="row">
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">اسم المنتج *</label>
            <input
              type="text"
              name="name"
              value={productData.name}
              onChange={handleChange}
              className={`form-control ${errors?.name ?"is-invalid":""}`}
              placeholder="ادخل اسم المنتج"
              required
            />
          </div>
           {errors?.name && <span className="error "> {errors?.name[0]}</span> }
        </div>

        
        
{!is_vendor && (
  <div className="col-md-6">
    <label className="form-label">المتجر</label>

    <EnhancedSearchStore
      product={true}
      setSectionType={setSectionType}
      setStoreId={setStoreId}
      setPrices={setPrices}
      setSectionId={setSectionId}
      value={
        productData.store_name
          ? { id: productData?.store_id, name: productData.store_name }
          : null
      }
      setErrors={setErrors}
    />

    {errors?.store_id && (
      <span className="error m-0">{errors?.store_id[0]}</span>
    )}
  </div>
)}

 
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">الفئة *</label>
            <Select  name="category_id"  isClearable options={groupedOptions}   value={categoryValue} onChange={handleChangeCategoryId}  placeholder={(isCategoriesLoading && productData.store_id) ?"جاري الفلترة":"اختر الفئة" }  disabled={isCategoriesLoading && productData.store_id}>  

            </Select>
     {errors?.category_id && <span className="error"> {errors?.category_id[0]}</span> }
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">الباركود</label>
            <input
              type="text"
              name="barcode"
              value={productData.barcode}
              onChange={handleChange}
              className="form-control"
              placeholder="ادخل الباركود"
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">الوزن</label>
            <input
              type="number"
              name="weight"
              value={productData.weight}
              onChange={handleChange}
              className="form-control"
              placeholder="ادخل الوزن"
            />
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">وقت التحضير</label>
            <input
              type="number"
              name="preparation_time"
              value={productData.preparation_time}
              onChange={handleChange}
              className="form-control"
              placeholder="وقت التحضير"
            />
          </div>
                  {errors?.preparation_time && <span className="error">{errors.preparation_time[0]}</span>}
        </div>

        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">وحدة وقت التحضير</label>
            <select
              name="preparation_time_unit"
              value={productData.preparation_time_unit}
              onChange={handleChange}
              className="form-select"
            >
              <option value="">اختر الوحدة</option>
              <option value="minute">دقائق</option>
              <option value="hour">ساعات</option>
            </select>
          </div>
        </div>

        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">الحد الأقصى للكمية في السلة</label>
            <input
              type="number"
              min={0}
              name="max_cart_quantity"
              max={99}
              value={productData?.max_cart_quantity}
              onChange={handleChange}
              className={`form-control ${errors?.max_cart_quantity ?"is-invalid":""}`}
              placeholder="ادخل الحد الأقصى"
            />
          </div>
           {errors?.max_cart_quantity && <span className="error"> {errors.max_cart_quantity[0]}</span> }
        </div>

       {section_type ==="pharmacy"&&   <PharmacyInfo setPharmacyInfo={setPharmacyInfo} pharmacyInfo={pharmacyInfo}/>}
        <div className="col-md-6">
          <div className="form-group mb-3">
            <label className="form-label">الحالة</label>
            <select
              name="status"
              value={productData.status}
              onChange={handleChange}
              className="form-select"
            >
              <option value="active">نشط</option>
              <option value="inactive">غير نشط</option>
            </select>
          </div>
        </div>

        <div className="col-12">
          <div className="form-group mb-3">
            <label className="form-label">وصف المنتج</label>
            <textarea
              name="description"
              value={productData.description}
              onChange={handleChange}
              className="form-control"
              placeholder="ادخل وصف المنتج بالتفاصيل"
              rows="4"
            ></textarea>
          </div>
        </div>

        <div className="col-12">
          <div className="form-group mb-3">
            <label className="form-label">ملاحظات</label>
            <textarea
              name="note"
              value={productData.note}
              onChange={handleChange}
              className="form-control"
              placeholder="ملاحظات إضافية"
              rows="2"
            ></textarea>
          </div>
        </div>
        {/* <ProductAvailability
          availability={availability}
          setAvailability={setAvailability}
          
        /> */}
      {section_type !== "pharmacy" && <div className="col-md-4">
          <label className="switch">
            <input
              type="checkbox"
              name="is_vegetarian"
              checked={productData.is_vegetarian === 1}
              onChange={handleChange}
              id="is_vegetarian"
            />
            <span className="slider round"></span>
          </label>
          <label className="form-check-label" htmlFor="is_vegetarian">
            نباتي
          </label>
        </div>}

        <div className="col-md-4">
          <label class="switch">
            <input
              type="checkbox"
              name="is_featured"
              checked={productData.is_featured === 1}
              onChange={handleChange}
              id="is_featured"
            />
            <span className="slider round"></span>
          </label>

          <label className="form-check-label" htmlFor="is_featured">
            مميز
          </label>
        </div>

        <div className="col-md-4">
          <label class="switch">
            <input
              type="checkbox"
              name="is_active"
              checked={productData.is_active === 1}
              onChange={handleChange}
              id="is_active"
            />
            <span className="slider round"></span>
          </label>

          <label className="form-check-label" htmlFor="is_featured">
            نشط
          </label>
        </div>
      </div>
    </div>
  );
};

export default ProductBasicInfo;
